import styled from "styled-components";

export const Container: any = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${(props: any) => (props?.aoVivo ? "#EAEFFF" : "#ffffff")};
  border: 1px solid #d5d5d5;
  border-radius: 8px;
  padding: 16px;
  margin-top: 10px;
  /* elevation: 2; */
`;

export const Row: any = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props: any) => (props.gap ? props?.gap : 0)}px;
  align-items: center;
`;

export const RowSpace = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Text = styled.p`
  color: #303030;

  font-family: Inter;
  font-size: 14.765px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.226px; /* 116.667% */
`;

export const Button = styled.button`
  display: flex;
  width: 142px;
  padding: 6.2px;
  justify-content: center;
  align-items: center;
  gap: 6.2px;
  border-radius: 6.2px;
  background: var(--Azul-Primary-200, #abbdff);
  box-shadow: 0px 0.947px 1.894px 0px rgba(16, 24, 40, 0.05);
  color: #2d5bff;
  cursor: pointer;
`;
